/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassAvailabilityDTO,
  ClassAvailabilityDTOOptional,
  ClassAvailabilityDTOMetaI,
  ClassAvailabilityDTOTrackedI,
} from "./class-availability-dto";
import {
  ClassAvailabilityDTOTracked,
  ClassAvailabilityDTOMeta,
} from "./class-availability-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassLocationDTO,
  ClassLocationDTOOptional,
  ClassLocationDTOMetaI,
  ClassLocationDTOTrackedI,
} from "./class-location-dto";
import {
  ClassLocationDTOTracked,
  ClassLocationDTOMeta,
} from "./class-location-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSectionDTO,
  ClassSectionDTOOptional,
  ClassSectionDTOMetaI,
  ClassSectionDTOTrackedI,
} from "./class-section-dto";
import {
  ClassSectionDTOTracked,
  ClassSectionDTOMeta,
} from "./class-section-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassSessionDTO,
  ClassSessionDTOOptional,
  ClassSessionDTOMetaI,
  ClassSessionDTOTrackedI,
} from "./class-session-dto";
import {
  ClassSessionDTOTracked,
  ClassSessionDTOMeta,
} from "./class-session-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassTypeDTO,
  ClassTypeDTOOptional,
  ClassTypeDTOMetaI,
  ClassTypeDTOTrackedI,
} from "./class-type-dto";
import { ClassTypeDTOTracked, ClassTypeDTOMeta } from "./class-type-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ClassTypeInfo,
  ClassTypeInfoOptional,
  ClassTypeInfoMetaI,
  ClassTypeInfoTrackedI,
} from "./class-type-info";
import { ClassTypeInfoTracked, ClassTypeInfoMeta } from "./class-type-info";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonNameInfoAndRef,
  PersonNameInfoAndRefOptional,
  PersonNameInfoAndRefMetaI,
  PersonNameInfoAndRefTrackedI,
} from "./person-name-info-and-ref";
import {
  PersonNameInfoAndRefTracked,
  PersonNameInfoAndRefMeta,
} from "./person-name-info-and-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ProgramTypeRefAndName,
  ProgramTypeRefAndNameOptional,
  ProgramTypeRefAndNameMetaI,
  ProgramTypeRefAndNameTrackedI,
} from "./program-type-ref-and-name";
import {
  ProgramTypeRefAndNameTracked,
  ProgramTypeRefAndNameMeta,
} from "./program-type-ref-and-name";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassInstanceWithType,
  UnifiedClassInstanceWithTypeOptional,
  UnifiedClassInstanceWithTypeMetaI,
  UnifiedClassInstanceWithTypeTrackedI,
} from "./unified-class-instance-with-type";
import {
  UnifiedClassInstanceWithTypeTracked,
  UnifiedClassInstanceWithTypeMeta,
} from "./unified-class-instance-with-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  UnifiedClassSignupRef,
  UnifiedClassSignupRefOptional,
  UnifiedClassSignupRefMetaI,
  UnifiedClassSignupRefTrackedI,
} from "./unified-class-signup-ref";
import {
  UnifiedClassSignupRefTracked,
  UnifiedClassSignupRefMeta,
} from "./unified-class-signup-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  WithSections,
  WithSectionsOptional,
  WithSectionsMetaI,
  WithSectionsTrackedI,
} from "./with-sections";
import { WithSectionsTracked, WithSectionsMeta } from "./with-sections";

/**
 *
 * @export
 * @interface ClassInstanceDTO
 */
export interface ClassInstanceDTOOptional extends ClassTypeInfoOptional {
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMax?: number;
  /**
   *
   * @type {ClassLocationDTO}
   * @memberof ClassInstanceDTO
   */
  locationId?: ClassLocationDTOOptional;
  /**
   *
   * @type {Array<ClassSessionDTO>}
   * @memberof ClassInstanceDTO
   */
  sessions?: ClassSessionDTOOptional[];
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassInstanceDTO
   */
  instructorId?: PersonNameInfoAndRefOptional;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof ClassInstanceDTO
   */
  signups?: UnifiedClassSignupRefOptional[];
  /**
   *
   * @type {ClassTypeDTO}
   * @memberof ClassInstanceDTO
   */
  typeId?: ClassTypeDTOOptional;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMin?: number;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  typeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  confirmTemplate?: string;
  /**
   *
   * @type {Array<ClassSectionDTO>}
   * @memberof ClassInstanceDTO
   */
  sections?: ClassSectionDTOOptional[];
  /**
   *
   * @type {ProgramTypeRefAndName}
   * @memberof ClassInstanceDTO
   */
  programId?: ProgramTypeRefAndNameOptional;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  weekNumber?: number;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  firstSessionDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  lastSessionDatetime?: Date;
  /**
   *
   * @type {ClassAvailabilityDTO}
   * @memberof ClassInstanceDTO
   */
  availability?: ClassAvailabilityDTOOptional;
}

export interface ClassInstanceDTO
  extends
    ClassInstanceDTOOptional,
    ClassTypeInfo,
    UnifiedClassInstanceWithType,
    WithSections {
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  assignId: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  price?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMax?: number;
  /**
   *
   * @type {ClassLocationDTO}
   * @memberof ClassInstanceDTO
   */
  locationId?: ClassLocationDTO;
  /**
   *
   * @type {Array<ClassSessionDTO>}
   * @memberof ClassInstanceDTO
   */
  sessions?: ClassSessionDTO[];
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassInstanceDTO
   */
  instructorId?: PersonNameInfoAndRef;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof ClassInstanceDTO
   */
  signups?: UnifiedClassSignupRef[];
  /**
   *
   * @type {ClassTypeDTO}
   * @memberof ClassInstanceDTO
   */
  typeId?: ClassTypeDTO;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionCt?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionLength?: number;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMin?: number;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  typeName?: string;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  adminHold?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noLimit?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noSignup?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  cancelledDatetime?: Date;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  allowMultiple?: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  confirmTemplate?: string;
  /**
   *
   * @type {Array<ClassSectionDTO>}
   * @memberof ClassInstanceDTO
   */
  sections?: ClassSectionDTO[];
  /**
   *
   * @type {ProgramTypeRefAndName}
   * @memberof ClassInstanceDTO
   */
  programId?: ProgramTypeRefAndName;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  weekNumber?: number;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  firstSessionDatetime?: Date;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  lastSessionDatetime?: Date;
  /**
   *
   * @type {ClassAvailabilityDTO}
   * @memberof ClassInstanceDTO
   */
  availability?: ClassAvailabilityDTO;
}

export interface ClassInstanceDTOTrackedI extends ClassTypeInfoOptional {
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  price?: number;
  priceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMax?: number;
  signupMaxIsSet: boolean;
  /**
   *
   * @type {ClassLocationDTO}
   * @memberof ClassInstanceDTO
   */
  locationId?: ClassLocationDTOTrackedI;
  locationIdIsSet: boolean;
  /**
   *
   * @type {Array<ClassSessionDTO>}
   * @memberof ClassInstanceDTO
   */
  sessions?: ClassSessionDTOTrackedI[];
  sessionsIsSet: boolean;
  /**
   *
   * @type {PersonNameInfoAndRef}
   * @memberof ClassInstanceDTO
   */
  instructorId?: PersonNameInfoAndRefTrackedI;
  instructorIdIsSet: boolean;
  /**
   *
   * @type {Array<UnifiedClassSignupRef>}
   * @memberof ClassInstanceDTO
   */
  signups?: UnifiedClassSignupRefTrackedI[];
  signupsIsSet: boolean;
  /**
   *
   * @type {ClassTypeDTO}
   * @memberof ClassInstanceDTO
   */
  typeId?: ClassTypeDTOTrackedI;
  typeIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionCt?: number;
  sessionCtIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  sessionLength?: number;
  sessionLengthIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  signupMin?: number;
  signupMinIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  typeName?: string;
  typeNameIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  adminHold?: boolean;
  adminHoldIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noLimit?: boolean;
  noLimitIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  noSignup?: boolean;
  noSignupIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  cancelledDatetime?: Date;
  cancelledDatetimeIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof ClassInstanceDTO
   */
  allowMultiple?: boolean;
  allowMultipleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  confirmTemplate?: string;
  confirmTemplateIsSet: boolean;
  /**
   *
   * @type {Array<ClassSectionDTO>}
   * @memberof ClassInstanceDTO
   */
  sections?: ClassSectionDTOTrackedI[];
  sectionsIsSet: boolean;
  /**
   *
   * @type {ProgramTypeRefAndName}
   * @memberof ClassInstanceDTO
   */
  programId?: ProgramTypeRefAndNameTrackedI;
  programIdIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof ClassInstanceDTO
   */
  weekNumber?: number;
  weekNumberIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  firstSessionDatetime?: Date;
  firstSessionDatetimeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof ClassInstanceDTO
   */
  lastSessionDatetime?: Date;
  lastSessionDatetimeIsSet: boolean;
  /**
   *
   * @type {ClassAvailabilityDTO}
   * @memberof ClassInstanceDTO
   */
  availability?: ClassAvailabilityDTOTrackedI;
  availabilityIsSet: boolean;
}

transformDatesMap.set("ClassInstanceDTO", function (model: ClassInstanceDTO) {
  const transformDateslocationId = transformDatesMap.get("ClassLocationDTO");
  if (transformDateslocationId && model.locationId) {
    transformDateslocationId(model.locationId);
  }
  const transformDatessessions = transformDatesMap.get("ClassSessionDTO");
  if (transformDatessessions) {
    model.sessions?.forEach((sub) => {
      transformDatessessions(sub);
    });
  }
  const transformDatesinstructorId = transformDatesMap.get(
    "PersonNameInfoAndRef",
  );
  if (transformDatesinstructorId && model.instructorId) {
    transformDatesinstructorId(model.instructorId);
  }
  const transformDatessignups = transformDatesMap.get("UnifiedClassSignupRef");
  if (transformDatessignups) {
    model.signups?.forEach((sub) => {
      transformDatessignups(sub);
    });
  }
  const transformDatestypeId = transformDatesMap.get("ClassTypeDTO");
  if (transformDatestypeId && model.typeId) {
    transformDatestypeId(model.typeId);
  }
  if (typeof model.cancelledDatetime == "string")
    model.cancelledDatetime = new Date(model.cancelledDatetime);
  const transformDatessections = transformDatesMap.get("ClassSectionDTO");
  if (transformDatessections) {
    model.sections?.forEach((sub) => {
      transformDatessections(sub);
    });
  }
  const transformDatesprogramId = transformDatesMap.get(
    "ProgramTypeRefAndName",
  );
  if (transformDatesprogramId && model.programId) {
    transformDatesprogramId(model.programId);
  }
  if (typeof model.firstSessionDatetime == "string")
    model.firstSessionDatetime = new Date(model.firstSessionDatetime);
  if (typeof model.lastSessionDatetime == "string")
    model.lastSessionDatetime = new Date(model.lastSessionDatetime);
  const transformDatesavailability = transformDatesMap.get(
    "ClassAvailabilityDTO",
  );
  if (transformDatesavailability && model.availability) {
    transformDatesavailability(model.availability);
  }
});

export type ClassInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  price: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMax: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  locationId: PropertyMeta<ClassLocationDTOMetaI>;
  //isDate: false
  //isDatetime: false
  sessions: PropertyMeta<ClassSessionDTOMetaI>;
  //isDate: false
  //isDatetime: false
  instructorId: PropertyMeta<PersonNameInfoAndRefMetaI>;
  //isDate: false
  //isDatetime: false
  signups: PropertyMeta<UnifiedClassSignupRefMetaI>;
  //isDate: false
  //isDatetime: false
  typeId: PropertyMeta<ClassTypeDTOMetaI>;
  //isDate: false
  //isDatetime: false
  sessionCt: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  sessionLength: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  signupMin: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  typeName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  adminHold: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noLimit: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  noSignup: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  cancelledDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  allowMultiple: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  confirmTemplate: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  sections: PropertyMeta<ClassSectionDTOMetaI>;
  //isDate: false
  //isDatetime: false
  programId: PropertyMeta<ProgramTypeRefAndNameMetaI>;
  //isDate: false
  //isDatetime: false
  weekNumber: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: true
  firstSessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  lastSessionDatetime: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  availability: PropertyMeta<ClassAvailabilityDTOMetaI>;
}>;

export var ClassInstanceDTOMeta: ClassInstanceDTOMetaI =
  {} as ClassInstanceDTOMetaI;
ClassInstanceDTOMeta = typeMeta("ClassInstanceDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  price: propertyMeta("price", false, false, false, MetaTypesBase.number),
  signupMax: propertyMeta(
    "signupMax",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  locationId: propertyMeta(
    "locationId",
    false,
    false,
    false,
    ClassLocationDTOMeta,
  ),
  sessions: propertyMeta("sessions", true, false, false, ClassSessionDTOMeta),
  instructorId: propertyMeta(
    "instructorId",
    false,
    false,
    false,
    PersonNameInfoAndRefMeta,
  ),
  signups: propertyMeta(
    "signups",
    true,
    false,
    false,
    UnifiedClassSignupRefMeta,
  ),
  typeId: propertyMeta("typeId", false, false, false, ClassTypeDTOMeta),
  sessionCt: propertyMeta(
    "sessionCt",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  sessionLength: propertyMeta(
    "sessionLength",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  signupMin: propertyMeta(
    "signupMin",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  typeName: propertyMeta("typeName", false, false, false, MetaTypesBase.string),
  adminHold: propertyMeta(
    "adminHold",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  noLimit: propertyMeta("noLimit", false, false, false, MetaTypesBase.boolean),
  noSignup: propertyMeta(
    "noSignup",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  cancelledDatetime: propertyMeta(
    "cancelledDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  allowMultiple: propertyMeta(
    "allowMultiple",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  confirmTemplate: propertyMeta(
    "confirmTemplate",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  sections: propertyMeta("sections", true, false, false, ClassSectionDTOMeta),
  programId: propertyMeta(
    "programId",
    false,
    false,
    false,
    ProgramTypeRefAndNameMeta,
  ),
  weekNumber: propertyMeta(
    "weekNumber",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  firstSessionDatetime: propertyMeta(
    "firstSessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  lastSessionDatetime: propertyMeta(
    "lastSessionDatetime",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  availability: propertyMeta(
    "availability",
    false,
    false,
    false,
    ClassAvailabilityDTOMeta,
  ),
});

const metaI = ClassInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    UnifiedClassInstanceWithTypeMeta,
  ]);
  metaI.assignId.inheritedFrom = UnifiedClassInstanceWithTypeMeta.assignId;
  metaI.price.inheritedFrom = UnifiedClassInstanceWithTypeMeta.price;
  metaI.signupMax.inheritedFrom = UnifiedClassInstanceWithTypeMeta.signupMax;
  metaI.locationId.inheritedFrom = UnifiedClassInstanceWithTypeMeta.locationId;
  metaI.sessions.inheritedFrom = UnifiedClassInstanceWithTypeMeta.sessions;
  metaI.instructorId.inheritedFrom =
    UnifiedClassInstanceWithTypeMeta.instructorId;
  metaI.signups.inheritedFrom = UnifiedClassInstanceWithTypeMeta.signups;
  metaI.typeId.inheritedFrom = UnifiedClassInstanceWithTypeMeta.typeId;
  metaI.interfaces = metaI.interfaces.concat([ClassTypeInfoMeta]);
  metaI.sessionCt.inheritedFrom = ClassTypeInfoMeta.sessionCt;
  metaI.sessionLength.inheritedFrom = ClassTypeInfoMeta.sessionLength;
  metaI.signupMax.inheritedFrom = ClassTypeInfoMeta.signupMax;
  metaI.signupMin.inheritedFrom = ClassTypeInfoMeta.signupMin;
  metaI.typeName.inheritedFrom = ClassTypeInfoMeta.typeName;
  metaI.adminHold.inheritedFrom = ClassTypeInfoMeta.adminHold;
  metaI.noLimit.inheritedFrom = ClassTypeInfoMeta.noLimit;
  metaI.noSignup.inheritedFrom = ClassTypeInfoMeta.noSignup;
  metaI.cancelledDatetime.inheritedFrom = ClassTypeInfoMeta.cancelledDatetime;
  metaI.allowMultiple.inheritedFrom = ClassTypeInfoMeta.allowMultiple;
  metaI.confirmTemplate.inheritedFrom = ClassTypeInfoMeta.confirmTemplate;
  metaI.interfaces = metaI.interfaces.concat([WithSectionsMeta]);
  metaI.sections.inheritedFrom = WithSectionsMeta.sections;
});

export class ClassInstanceDTOTracked
  extends ClassTypeInfoTracked
  implements ClassInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  price__I?: number = undefined;
  priceIsSet: boolean = false;
  set price(v: undefined | number) {
    if (v !== undefined) {
      this.price__I = v;
      this.priceIsSet = true;
    } else {
      this.price__I = v || undefined;
      this.priceIsSet = false;
    }
    this.changeTracker = true;
  }
  get price() {
    return this.price__I;
  }
  signupMax__I?: number = undefined;
  signupMaxIsSet: boolean = false;
  set signupMax(v: undefined | number) {
    if (v !== undefined) {
      this.signupMax__I = v;
      this.signupMaxIsSet = true;
    } else {
      this.signupMax__I = v || undefined;
      this.signupMaxIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMax() {
    return this.signupMax__I;
  }
  locationId__I?: ClassLocationDTOTracked = undefined;
  locationIdIsSet: boolean = false;
  set locationId(v: undefined | ClassLocationDTOTracked) {
    if (v !== undefined) {
      this.locationId__I = v;
      this.locationIdIsSet = true;
    } else {
      this.locationId__I = v || undefined;
      this.locationIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get locationId() {
    return this.locationId__I;
  }
  sessions__I?: ClassSessionDTOTracked[] = undefined;
  sessionsIsSet: boolean = false;
  set sessions(v: undefined | ClassSessionDTOTracked[]) {
    if (v !== undefined) {
      this.sessions__I = v;
      this.sessionsIsSet = true;
    } else {
      this.sessions__I = v || undefined;
      this.sessionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessions() {
    return this.sessions__I;
  }
  instructorId__I?: PersonNameInfoAndRefTracked = undefined;
  instructorIdIsSet: boolean = false;
  set instructorId(v: undefined | PersonNameInfoAndRefTracked) {
    if (v !== undefined) {
      this.instructorId__I = v;
      this.instructorIdIsSet = true;
    } else {
      this.instructorId__I = v || undefined;
      this.instructorIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instructorId() {
    return this.instructorId__I;
  }
  signups__I?: UnifiedClassSignupRefTracked[] = undefined;
  signupsIsSet: boolean = false;
  set signups(v: undefined | UnifiedClassSignupRefTracked[]) {
    if (v !== undefined) {
      this.signups__I = v;
      this.signupsIsSet = true;
    } else {
      this.signups__I = v || undefined;
      this.signupsIsSet = false;
    }
    this.changeTracker = true;
  }
  get signups() {
    return this.signups__I;
  }
  typeId__I?: ClassTypeDTOTracked = undefined;
  typeIdIsSet: boolean = false;
  set typeId(v: undefined | ClassTypeDTOTracked) {
    if (v !== undefined) {
      this.typeId__I = v;
      this.typeIdIsSet = true;
    } else {
      this.typeId__I = v || undefined;
      this.typeIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeId() {
    return this.typeId__I;
  }
  sessionCt__I?: number = undefined;
  sessionCtIsSet: boolean = false;
  set sessionCt(v: undefined | number) {
    if (v !== undefined) {
      this.sessionCt__I = v;
      this.sessionCtIsSet = true;
    } else {
      this.sessionCt__I = v || undefined;
      this.sessionCtIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionCt() {
    return this.sessionCt__I;
  }
  sessionLength__I?: number = undefined;
  sessionLengthIsSet: boolean = false;
  set sessionLength(v: undefined | number) {
    if (v !== undefined) {
      this.sessionLength__I = v;
      this.sessionLengthIsSet = true;
    } else {
      this.sessionLength__I = v || undefined;
      this.sessionLengthIsSet = false;
    }
    this.changeTracker = true;
  }
  get sessionLength() {
    return this.sessionLength__I;
  }
  signupMin__I?: number = undefined;
  signupMinIsSet: boolean = false;
  set signupMin(v: undefined | number) {
    if (v !== undefined) {
      this.signupMin__I = v;
      this.signupMinIsSet = true;
    } else {
      this.signupMin__I = v || undefined;
      this.signupMinIsSet = false;
    }
    this.changeTracker = true;
  }
  get signupMin() {
    return this.signupMin__I;
  }
  typeName__I?: string = undefined;
  typeNameIsSet: boolean = false;
  set typeName(v: undefined | string) {
    if (v !== undefined) {
      this.typeName__I = v;
      this.typeNameIsSet = true;
    } else {
      this.typeName__I = v || undefined;
      this.typeNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeName() {
    return this.typeName__I;
  }
  adminHold__I?: boolean = undefined;
  adminHoldIsSet: boolean = false;
  set adminHold(v: undefined | boolean) {
    if (v !== undefined) {
      this.adminHold__I = v;
      this.adminHoldIsSet = true;
    } else {
      this.adminHold__I = v || undefined;
      this.adminHoldIsSet = false;
    }
    this.changeTracker = true;
  }
  get adminHold() {
    return this.adminHold__I;
  }
  noLimit__I?: boolean = undefined;
  noLimitIsSet: boolean = false;
  set noLimit(v: undefined | boolean) {
    if (v !== undefined) {
      this.noLimit__I = v;
      this.noLimitIsSet = true;
    } else {
      this.noLimit__I = v || undefined;
      this.noLimitIsSet = false;
    }
    this.changeTracker = true;
  }
  get noLimit() {
    return this.noLimit__I;
  }
  noSignup__I?: boolean = undefined;
  noSignupIsSet: boolean = false;
  set noSignup(v: undefined | boolean) {
    if (v !== undefined) {
      this.noSignup__I = v;
      this.noSignupIsSet = true;
    } else {
      this.noSignup__I = v || undefined;
      this.noSignupIsSet = false;
    }
    this.changeTracker = true;
  }
  get noSignup() {
    return this.noSignup__I;
  }
  cancelledDatetime__I?: Date = undefined;
  cancelledDatetimeIsSet: boolean = false;
  set cancelledDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.cancelledDatetime__I = v;
      this.cancelledDatetimeIsSet = true;
    } else {
      this.cancelledDatetime__I = v || undefined;
      this.cancelledDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get cancelledDatetime() {
    return this.cancelledDatetime__I;
  }
  allowMultiple__I?: boolean = undefined;
  allowMultipleIsSet: boolean = false;
  set allowMultiple(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowMultiple__I = v;
      this.allowMultipleIsSet = true;
    } else {
      this.allowMultiple__I = v || undefined;
      this.allowMultipleIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowMultiple() {
    return this.allowMultiple__I;
  }
  confirmTemplate__I?: string = undefined;
  confirmTemplateIsSet: boolean = false;
  set confirmTemplate(v: undefined | string) {
    if (v !== undefined) {
      this.confirmTemplate__I = v;
      this.confirmTemplateIsSet = true;
    } else {
      this.confirmTemplate__I = v || undefined;
      this.confirmTemplateIsSet = false;
    }
    this.changeTracker = true;
  }
  get confirmTemplate() {
    return this.confirmTemplate__I;
  }
  sections__I?: ClassSectionDTOTracked[] = undefined;
  sectionsIsSet: boolean = false;
  set sections(v: undefined | ClassSectionDTOTracked[]) {
    if (v !== undefined) {
      this.sections__I = v;
      this.sectionsIsSet = true;
    } else {
      this.sections__I = v || undefined;
      this.sectionsIsSet = false;
    }
    this.changeTracker = true;
  }
  get sections() {
    return this.sections__I;
  }
  programId__I?: ProgramTypeRefAndNameTracked = undefined;
  programIdIsSet: boolean = false;
  set programId(v: undefined | ProgramTypeRefAndNameTracked) {
    if (v !== undefined) {
      this.programId__I = v;
      this.programIdIsSet = true;
    } else {
      this.programId__I = v || undefined;
      this.programIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get programId() {
    return this.programId__I;
  }
  weekNumber__I?: number = undefined;
  weekNumberIsSet: boolean = false;
  set weekNumber(v: undefined | number) {
    if (v !== undefined) {
      this.weekNumber__I = v;
      this.weekNumberIsSet = true;
    } else {
      this.weekNumber__I = v || undefined;
      this.weekNumberIsSet = false;
    }
    this.changeTracker = true;
  }
  get weekNumber() {
    return this.weekNumber__I;
  }
  firstSessionDatetime__I?: Date = undefined;
  firstSessionDatetimeIsSet: boolean = false;
  set firstSessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.firstSessionDatetime__I = v;
      this.firstSessionDatetimeIsSet = true;
    } else {
      this.firstSessionDatetime__I = v || undefined;
      this.firstSessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get firstSessionDatetime() {
    return this.firstSessionDatetime__I;
  }
  lastSessionDatetime__I?: Date = undefined;
  lastSessionDatetimeIsSet: boolean = false;
  set lastSessionDatetime(v: undefined | Date) {
    if (v !== undefined) {
      this.lastSessionDatetime__I = v;
      this.lastSessionDatetimeIsSet = true;
    } else {
      this.lastSessionDatetime__I = v || undefined;
      this.lastSessionDatetimeIsSet = false;
    }
    this.changeTracker = true;
  }
  get lastSessionDatetime() {
    return this.lastSessionDatetime__I;
  }
  availability__I?: ClassAvailabilityDTOTracked = undefined;
  availabilityIsSet: boolean = false;
  set availability(v: undefined | ClassAvailabilityDTOTracked) {
    if (v !== undefined) {
      this.availability__I = v;
      this.availabilityIsSet = true;
    } else {
      this.availability__I = v || undefined;
      this.availabilityIsSet = false;
    }
    this.changeTracker = true;
  }
  get availability() {
    return this.availability__I;
  }
  constructor(config?: ClassInstanceDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.locationId?.setIds();

    this.sessions?.forEach((a) => a.setIds());
    this.instructorId?.setIds();

    this.signups?.forEach((a) => a.setIds());
    this.typeId?.setIds();

    this.sections?.forEach((a) => a.setIds());
    this.programId?.setIds();

    this.availability?.setIds();
  }
  assignFrom(
    config: ClassInstanceDTOOptional,
    options?: AssignOptions,
  ): ClassInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.price && this.priceApplyFilter(optionsRequired.filter)) {
      this.price = config.price;
      if (optionsRequired.unassign) this.priceIsSet = false;
      else this.priceIsSet = true;
    }
    if (config.signupMax && this.signupMaxApplyFilter(optionsRequired.filter)) {
      this.signupMax = config.signupMax;
      if (optionsRequired.unassign) this.signupMaxIsSet = false;
      else this.signupMaxIsSet = true;
    }
    if (
      config.locationId &&
      this.locationIdApplyFilter(optionsRequired.filter)
    ) {
      this.locationId = new ClassLocationDTOTracked(config.locationId, options);
      if (optionsRequired.unassign) this.locationIdIsSet = false;
      else this.locationIdIsSet = true;
    }
    if (config.sessions && this.sessionsApplyFilter(optionsRequired.filter)) {
      this.sessions = config.sessions?.map(
        (a) => new ClassSessionDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.sessionsIsSet = false;
      else this.sessionsIsSet = true;
    }
    if (
      config.instructorId &&
      this.instructorIdApplyFilter(optionsRequired.filter)
    ) {
      this.instructorId = new PersonNameInfoAndRefTracked(
        config.instructorId,
        options,
      );
      if (optionsRequired.unassign) this.instructorIdIsSet = false;
      else this.instructorIdIsSet = true;
    }
    if (config.signups && this.signupsApplyFilter(optionsRequired.filter)) {
      this.signups = config.signups?.map(
        (a) => new UnifiedClassSignupRefTracked(a, options),
      );
      if (optionsRequired.unassign) this.signupsIsSet = false;
      else this.signupsIsSet = true;
    }
    if (config.typeId && this.typeIdApplyFilter(optionsRequired.filter)) {
      this.typeId = new ClassTypeDTOTracked(config.typeId, options);
      if (optionsRequired.unassign) this.typeIdIsSet = false;
      else this.typeIdIsSet = true;
    }
    if (config.sessionCt && this.sessionCtApplyFilter(optionsRequired.filter)) {
      this.sessionCt = config.sessionCt;
      if (optionsRequired.unassign) this.sessionCtIsSet = false;
      else this.sessionCtIsSet = true;
    }
    if (
      config.sessionLength &&
      this.sessionLengthApplyFilter(optionsRequired.filter)
    ) {
      this.sessionLength = config.sessionLength;
      if (optionsRequired.unassign) this.sessionLengthIsSet = false;
      else this.sessionLengthIsSet = true;
    }
    if (config.signupMin && this.signupMinApplyFilter(optionsRequired.filter)) {
      this.signupMin = config.signupMin;
      if (optionsRequired.unassign) this.signupMinIsSet = false;
      else this.signupMinIsSet = true;
    }
    if (config.typeName && this.typeNameApplyFilter(optionsRequired.filter)) {
      this.typeName = config.typeName;
      if (optionsRequired.unassign) this.typeNameIsSet = false;
      else this.typeNameIsSet = true;
    }
    if (config.adminHold && this.adminHoldApplyFilter(optionsRequired.filter)) {
      this.adminHold = config.adminHold;
      if (optionsRequired.unassign) this.adminHoldIsSet = false;
      else this.adminHoldIsSet = true;
    }
    if (config.noLimit && this.noLimitApplyFilter(optionsRequired.filter)) {
      this.noLimit = config.noLimit;
      if (optionsRequired.unassign) this.noLimitIsSet = false;
      else this.noLimitIsSet = true;
    }
    if (config.noSignup && this.noSignupApplyFilter(optionsRequired.filter)) {
      this.noSignup = config.noSignup;
      if (optionsRequired.unassign) this.noSignupIsSet = false;
      else this.noSignupIsSet = true;
    }
    if (
      config.cancelledDatetime &&
      this.cancelledDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.cancelledDatetime = config.cancelledDatetime;
      if (optionsRequired.unassign) this.cancelledDatetimeIsSet = false;
      else this.cancelledDatetimeIsSet = true;
    }
    if (
      config.allowMultiple &&
      this.allowMultipleApplyFilter(optionsRequired.filter)
    ) {
      this.allowMultiple = config.allowMultiple;
      if (optionsRequired.unassign) this.allowMultipleIsSet = false;
      else this.allowMultipleIsSet = true;
    }
    if (
      config.confirmTemplate &&
      this.confirmTemplateApplyFilter(optionsRequired.filter)
    ) {
      this.confirmTemplate = config.confirmTemplate;
      if (optionsRequired.unassign) this.confirmTemplateIsSet = false;
      else this.confirmTemplateIsSet = true;
    }
    if (config.sections && this.sectionsApplyFilter(optionsRequired.filter)) {
      this.sections = config.sections?.map(
        (a) => new ClassSectionDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.sectionsIsSet = false;
      else this.sectionsIsSet = true;
    }
    if (config.programId && this.programIdApplyFilter(optionsRequired.filter)) {
      this.programId = new ProgramTypeRefAndNameTracked(
        config.programId,
        options,
      );
      if (optionsRequired.unassign) this.programIdIsSet = false;
      else this.programIdIsSet = true;
    }
    if (
      config.weekNumber &&
      this.weekNumberApplyFilter(optionsRequired.filter)
    ) {
      this.weekNumber = config.weekNumber;
      if (optionsRequired.unassign) this.weekNumberIsSet = false;
      else this.weekNumberIsSet = true;
    }
    if (
      config.firstSessionDatetime &&
      this.firstSessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.firstSessionDatetime = config.firstSessionDatetime;
      if (optionsRequired.unassign) this.firstSessionDatetimeIsSet = false;
      else this.firstSessionDatetimeIsSet = true;
    }
    if (
      config.lastSessionDatetime &&
      this.lastSessionDatetimeApplyFilter(optionsRequired.filter)
    ) {
      this.lastSessionDatetime = config.lastSessionDatetime;
      if (optionsRequired.unassign) this.lastSessionDatetimeIsSet = false;
      else this.lastSessionDatetimeIsSet = true;
    }
    if (
      config.availability &&
      this.availabilityApplyFilter(optionsRequired.filter)
    ) {
      this.availability = new ClassAvailabilityDTOTracked(
        config.availability,
        options,
      );
      if (optionsRequired.unassign) this.availabilityIsSet = false;
      else this.availabilityIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): ClassInstanceDTOTrackedI {
    const cloned = {} as ClassInstanceDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.priceIsSetDeep() &&
      this.priceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.priceIsSet = true;
      cloned.price = this.price;
    } else {
      //cloned.priceIsSet = false
    }
    if (
      this.signupMaxIsSetDeep() &&
      this.signupMaxApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMaxIsSet = true;
      cloned.signupMax = this.signupMax;
    } else {
      //cloned.signupMaxIsSet = false
    }
    if (
      this.locationIdIsSetDeep() &&
      this.locationIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.locationIdIsSet = true;
      cloned.locationId = this.locationId?.removeUnset(filter);
    } else {
      //cloned.locationIdIsSet = false
    }
    if (
      this.sessionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.sessionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionsIsSet = true;
      cloned.sessions = this.sessions
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.sessionsIsSet = false
    }
    if (
      this.instructorIdIsSetDeep() &&
      this.instructorIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instructorIdIsSet = true;
      cloned.instructorId = this.instructorId?.removeUnset(filter);
    } else {
      //cloned.instructorIdIsSet = false
    }
    if (
      this.signupsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.signupsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupsIsSet = true;
      cloned.signups = this.signups
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.signupsIsSet = false
    }
    if (
      this.typeIdIsSetDeep() &&
      this.typeIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeIdIsSet = true;
      cloned.typeId = this.typeId?.removeUnset(filter);
    } else {
      //cloned.typeIdIsSet = false
    }
    if (
      this.sessionCtIsSetDeep() &&
      this.sessionCtApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionCtIsSet = true;
      cloned.sessionCt = this.sessionCt;
    } else {
      //cloned.sessionCtIsSet = false
    }
    if (
      this.sessionLengthIsSetDeep() &&
      this.sessionLengthApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sessionLengthIsSet = true;
      cloned.sessionLength = this.sessionLength;
    } else {
      //cloned.sessionLengthIsSet = false
    }
    if (
      this.signupMinIsSetDeep() &&
      this.signupMinApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.signupMinIsSet = true;
      cloned.signupMin = this.signupMin;
    } else {
      //cloned.signupMinIsSet = false
    }
    if (
      this.typeNameIsSetDeep() &&
      this.typeNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeNameIsSet = true;
      cloned.typeName = this.typeName;
    } else {
      //cloned.typeNameIsSet = false
    }
    if (
      this.adminHoldIsSetDeep() &&
      this.adminHoldApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.adminHoldIsSet = true;
      cloned.adminHold = this.adminHold;
    } else {
      //cloned.adminHoldIsSet = false
    }
    if (
      this.noLimitIsSetDeep() &&
      this.noLimitApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noLimitIsSet = true;
      cloned.noLimit = this.noLimit;
    } else {
      //cloned.noLimitIsSet = false
    }
    if (
      this.noSignupIsSetDeep() &&
      this.noSignupApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.noSignupIsSet = true;
      cloned.noSignup = this.noSignup;
    } else {
      //cloned.noSignupIsSet = false
    }
    if (
      this.cancelledDatetimeIsSetDeep() &&
      this.cancelledDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.cancelledDatetimeIsSet = true;
      cloned.cancelledDatetime = this.cancelledDatetime;
    } else {
      //cloned.cancelledDatetimeIsSet = false
    }
    if (
      this.allowMultipleIsSetDeep() &&
      this.allowMultipleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowMultipleIsSet = true;
      cloned.allowMultiple = this.allowMultiple;
    } else {
      //cloned.allowMultipleIsSet = false
    }
    if (
      this.confirmTemplateIsSetDeep() &&
      this.confirmTemplateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.confirmTemplateIsSet = true;
      cloned.confirmTemplate = this.confirmTemplate;
    } else {
      //cloned.confirmTemplateIsSet = false
    }
    if (
      this.sectionsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.sectionsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.sectionsIsSet = true;
      cloned.sections = this.sections
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.sectionsIsSet = false
    }
    if (
      this.programIdIsSetDeep() &&
      this.programIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.programIdIsSet = true;
      cloned.programId = this.programId?.removeUnset(filter);
    } else {
      //cloned.programIdIsSet = false
    }
    if (
      this.weekNumberIsSetDeep() &&
      this.weekNumberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.weekNumberIsSet = true;
      cloned.weekNumber = this.weekNumber;
    } else {
      //cloned.weekNumberIsSet = false
    }
    if (
      this.firstSessionDatetimeIsSetDeep() &&
      this.firstSessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstSessionDatetimeIsSet = true;
      cloned.firstSessionDatetime = this.firstSessionDatetime;
    } else {
      //cloned.firstSessionDatetimeIsSet = false
    }
    if (
      this.lastSessionDatetimeIsSetDeep() &&
      this.lastSessionDatetimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastSessionDatetimeIsSet = true;
      cloned.lastSessionDatetime = this.lastSessionDatetime;
    } else {
      //cloned.lastSessionDatetimeIsSet = false
    }
    if (
      this.availabilityIsSetDeep() &&
      this.availabilityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.availabilityIsSet = true;
      cloned.availability = this.availability?.removeUnset(filter);
    } else {
      //cloned.availabilityIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): ClassInstanceDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.priceApplyFilter(filter)) this.priceIsSet = false;

    if (!this.signupMaxApplyFilter(filter)) this.signupMaxIsSet = false;

    if (!this.locationIdApplyFilter(filter)) this.locationIdIsSet = false;
    this.locationId?.unassignAll(filter);

    if (!this.sessionsApplyFilter(filter)) this.sessionsIsSet = false;

    this.sessions?.forEach((a) => a.unassignAll(filter));
    if (!this.instructorIdApplyFilter(filter)) this.instructorIdIsSet = false;
    this.instructorId?.unassignAll(filter);

    if (!this.signupsApplyFilter(filter)) this.signupsIsSet = false;

    this.signups?.forEach((a) => a.unassignAll(filter));
    if (!this.typeIdApplyFilter(filter)) this.typeIdIsSet = false;
    this.typeId?.unassignAll(filter);

    if (!this.sessionCtApplyFilter(filter)) this.sessionCtIsSet = false;

    if (!this.sessionLengthApplyFilter(filter)) this.sessionLengthIsSet = false;

    if (!this.signupMinApplyFilter(filter)) this.signupMinIsSet = false;

    if (!this.typeNameApplyFilter(filter)) this.typeNameIsSet = false;

    if (!this.adminHoldApplyFilter(filter)) this.adminHoldIsSet = false;

    if (!this.noLimitApplyFilter(filter)) this.noLimitIsSet = false;

    if (!this.noSignupApplyFilter(filter)) this.noSignupIsSet = false;

    if (!this.cancelledDatetimeApplyFilter(filter))
      this.cancelledDatetimeIsSet = false;

    if (!this.allowMultipleApplyFilter(filter)) this.allowMultipleIsSet = false;

    if (!this.confirmTemplateApplyFilter(filter))
      this.confirmTemplateIsSet = false;

    if (!this.sectionsApplyFilter(filter)) this.sectionsIsSet = false;

    this.sections?.forEach((a) => a.unassignAll(filter));
    if (!this.programIdApplyFilter(filter)) this.programIdIsSet = false;
    this.programId?.unassignAll(filter);

    if (!this.weekNumberApplyFilter(filter)) this.weekNumberIsSet = false;

    if (!this.firstSessionDatetimeApplyFilter(filter))
      this.firstSessionDatetimeIsSet = false;

    if (!this.lastSessionDatetimeApplyFilter(filter))
      this.lastSessionDatetimeIsSet = false;

    if (!this.availabilityApplyFilter(filter)) this.availabilityIsSet = false;
    this.availability?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.assignId,
      ClassInstanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  priceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.price,
      ClassInstanceDTOMeta,
      this.price,
      this,
    );
  }
  priceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.priceIsSet && this.priceApplyFilter(filter)) return true;

    return false;
  }
  signupMaxApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.signupMax,
      ClassInstanceDTOMeta,
      this.signupMax,
      this,
    );
  }
  signupMaxIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMaxIsSet && this.signupMaxApplyFilter(filter)) return true;

    return false;
  }
  locationIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.locationId,
      ClassInstanceDTOMeta,
      this.locationId,
      this,
    );
  }
  locationIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.locationIdIsSet && this.locationIdApplyFilter(filter)) return true;
    return this.locationId?.anySet(filter) == true;

    return false;
  }
  sessionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.sessions,
      ClassInstanceDTOMeta,
      this.sessions,
      this,
    );
  }
  sessionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionsIsSet && this.sessionsApplyFilter(filter)) return true;

    return this.sessions?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  instructorIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.instructorId,
      ClassInstanceDTOMeta,
      this.instructorId,
      this,
    );
  }
  instructorIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instructorIdIsSet && this.instructorIdApplyFilter(filter))
      return true;
    return this.instructorId?.anySet(filter) == true;

    return false;
  }
  signupsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.signups,
      ClassInstanceDTOMeta,
      this.signups,
      this,
    );
  }
  signupsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupsIsSet && this.signupsApplyFilter(filter)) return true;

    return this.signups?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.typeId,
      ClassInstanceDTOMeta,
      this.typeId,
      this,
    );
  }
  typeIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeIdIsSet && this.typeIdApplyFilter(filter)) return true;
    return this.typeId?.anySet(filter) == true;

    return false;
  }
  sessionCtApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.sessionCt,
      ClassInstanceDTOMeta,
      this.sessionCt,
      this,
    );
  }
  sessionCtIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionCtIsSet && this.sessionCtApplyFilter(filter)) return true;

    return false;
  }
  sessionLengthApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.sessionLength,
      ClassInstanceDTOMeta,
      this.sessionLength,
      this,
    );
  }
  sessionLengthIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sessionLengthIsSet && this.sessionLengthApplyFilter(filter))
      return true;

    return false;
  }
  signupMinApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.signupMin,
      ClassInstanceDTOMeta,
      this.signupMin,
      this,
    );
  }
  signupMinIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.signupMinIsSet && this.signupMinApplyFilter(filter)) return true;

    return false;
  }
  typeNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.typeName,
      ClassInstanceDTOMeta,
      this.typeName,
      this,
    );
  }
  typeNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeNameIsSet && this.typeNameApplyFilter(filter)) return true;

    return false;
  }
  adminHoldApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.adminHold,
      ClassInstanceDTOMeta,
      this.adminHold,
      this,
    );
  }
  adminHoldIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.adminHoldIsSet && this.adminHoldApplyFilter(filter)) return true;

    return false;
  }
  noLimitApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.noLimit,
      ClassInstanceDTOMeta,
      this.noLimit,
      this,
    );
  }
  noLimitIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noLimitIsSet && this.noLimitApplyFilter(filter)) return true;

    return false;
  }
  noSignupApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.noSignup,
      ClassInstanceDTOMeta,
      this.noSignup,
      this,
    );
  }
  noSignupIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.noSignupIsSet && this.noSignupApplyFilter(filter)) return true;

    return false;
  }
  cancelledDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.cancelledDatetime,
      ClassInstanceDTOMeta,
      this.cancelledDatetime,
      this,
    );
  }
  cancelledDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.cancelledDatetimeIsSet &&
      this.cancelledDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  allowMultipleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.allowMultiple,
      ClassInstanceDTOMeta,
      this.allowMultiple,
      this,
    );
  }
  allowMultipleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowMultipleIsSet && this.allowMultipleApplyFilter(filter))
      return true;

    return false;
  }
  confirmTemplateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.confirmTemplate,
      ClassInstanceDTOMeta,
      this.confirmTemplate,
      this,
    );
  }
  confirmTemplateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.confirmTemplateIsSet && this.confirmTemplateApplyFilter(filter))
      return true;

    return false;
  }
  sectionsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.sections,
      ClassInstanceDTOMeta,
      this.sections,
      this,
    );
  }
  sectionsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.sectionsIsSet && this.sectionsApplyFilter(filter)) return true;

    return this.sections?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  programIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.programId,
      ClassInstanceDTOMeta,
      this.programId,
      this,
    );
  }
  programIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.programIdIsSet && this.programIdApplyFilter(filter)) return true;
    return this.programId?.anySet(filter) == true;

    return false;
  }
  weekNumberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.weekNumber,
      ClassInstanceDTOMeta,
      this.weekNumber,
      this,
    );
  }
  weekNumberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.weekNumberIsSet && this.weekNumberApplyFilter(filter)) return true;

    return false;
  }
  firstSessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.firstSessionDatetime,
      ClassInstanceDTOMeta,
      this.firstSessionDatetime,
      this,
    );
  }
  firstSessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.firstSessionDatetimeIsSet &&
      this.firstSessionDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  lastSessionDatetimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.lastSessionDatetime,
      ClassInstanceDTOMeta,
      this.lastSessionDatetime,
      this,
    );
  }
  lastSessionDatetimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.lastSessionDatetimeIsSet &&
      this.lastSessionDatetimeApplyFilter(filter)
    )
      return true;

    return false;
  }
  availabilityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      ClassInstanceDTOMeta.availability,
      ClassInstanceDTOMeta,
      this.availability,
      this,
    );
  }
  availabilityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.availabilityIsSet && this.availabilityApplyFilter(filter))
      return true;
    return this.availability?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.priceIsSetDeep(filter)) return true;
    if (this.signupMaxIsSetDeep(filter)) return true;
    if (this.locationIdIsSetDeep(filter)) return true;
    if (this.sessionsIsSetDeep(filter)) return true;
    if (this.instructorIdIsSetDeep(filter)) return true;
    if (this.signupsIsSetDeep(filter)) return true;
    if (this.typeIdIsSetDeep(filter)) return true;
    if (this.sessionCtIsSetDeep(filter)) return true;
    if (this.sessionLengthIsSetDeep(filter)) return true;
    if (this.signupMinIsSetDeep(filter)) return true;
    if (this.typeNameIsSetDeep(filter)) return true;
    if (this.adminHoldIsSetDeep(filter)) return true;
    if (this.noLimitIsSetDeep(filter)) return true;
    if (this.noSignupIsSetDeep(filter)) return true;
    if (this.cancelledDatetimeIsSetDeep(filter)) return true;
    if (this.allowMultipleIsSetDeep(filter)) return true;
    if (this.confirmTemplateIsSetDeep(filter)) return true;
    if (this.sectionsIsSetDeep(filter)) return true;
    if (this.programIdIsSetDeep(filter)) return true;
    if (this.weekNumberIsSetDeep(filter)) return true;
    if (this.firstSessionDatetimeIsSetDeep(filter)) return true;
    if (this.lastSessionDatetimeIsSetDeep(filter)) return true;
    if (this.availabilityIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
